export const INIT_STYLES = 'INIT_STYLES';
export const INIT_BRAND = 'INIT_BRAND';
export const INIT_SETTINGS = 'INIT_SETTINGS';
